import { Component } from '@angular/core';

@Component({
  selector: 'app-table-resize',
  templateUrl: './table-resize.component.html',
  styleUrls: ['./table-resize.component.scss']
})
export class TableResizeComponent {

}
